import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ShopEditFormShop from './ShopEditFormShop';
// import CloseButton from '../../components/atoms/CloseButton';

const styles = {
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  detailTtl: {
    fontSize: 20,
    color: '#333333',
    padding: '15px 10px 10px'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    editInput,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    handleChangePage,
    isFukuoka,
    listBank,
    listBankBranch,
    educateSystem
  }) => {
    console.log('editInput', editInput);
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.detailTtl}>
          {isFukuoka ? '教室情報編集' : '店舗情報編集'}
        </Typography>
        <div>
          <ShopEditFormShop
            editInput={editInput}
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            handleChangePage={handleChangePage}
            isFukuoka={isFukuoka}
            listBank={listBank}
            listBankBranch={listBankBranch}
            educateSystem={educateSystem}
          />
        </div>
        {/* <div>
        <CloseButton onClickAction={closeAction} />
      </div> */}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
